import gql from 'graphql-tag';

export const MUTATION_AGENTLOGIN = gql`
  mutation agentLogin($input: AgentLoginInput) {
    agentLogin(input: $input) {
      authToken
    }
  }
`;

export const MUTATION_AGENTSIGUP = gql`
  mutation agentSignUp($input: AgentSignUpInput) {
    agentSignUp(input: $input) {
      authToken
    }
  }
`;

export const MUTATION_AGENTFORGETPASSWORD = gql`
  mutation LP_ForgotPassword($email: String!, $portal: Portal) {
    forgotPassword(email: $email, portal: $portal) {
      success
    }
  }
`;

export const MUTATION_AGENTSETPASSWORD = gql`
  mutation LP_SetPassword($newPassword: String!, $portal: Portal, $token: String!) {
    resetPassword(newPassword: $newPassword, portal: $portal, token: $token) {
      success
    }
  }
`;
